/*
 * @Author       : LQ
 * @Description  :
 * @version      : 3.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : jry
 * @lastTime     : 2025-08-16 10:52:35
 * @FilePath     : /uview-plus/libs/config/props/actionSheet.js
 */
export default {
    // action-sheet组件
    actionSheet: {
        show: false,
        title: '',
        description: '',
        actions: [],
        index: '',
        cancelText: '',
        closeOnClickAction: true,
        safeAreaInsetBottom: true,
        openType: '',
        closeOnClickOverlay: true,
        round: 0,
        wrapMaxHeight: '600px'
    }
}
